import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../../Store/Language";

// components
import LanguageIcon from "./LanguageIcon";

const LanguageBtn = ({ navBtn }) => {
  const { language } = useSelector((state) => state.lang);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleLanguageChange = () => {
    const newLang = language === "en" ? "ar" : "en";
    dispatch(setLanguage(newLang));
  };

  return (
    <button
      type="button"
      onClick={handleLanguageChange}
      className={`language-btn ${
        navBtn
          ? "language-btn--nav px-lg-2 flex-lg-column"
          : "language-btn--footer flex-row-reverse p-0"
      } outline-none border-0 shadow-none bg-transparent d-inline-flex align-items-center`}
    >
      <LanguageIcon />
      <span className="fsize--6 language-btn__title text-capitalize text--white fw-bold">
        {t("language")}
      </span>
    </button>
  );
};

export default LanguageBtn;
